import { useRouter } from '#app';

export default defineNuxtPlugin(() => {
  const router = useRouter();

  router.afterEach((to, from) => {
    if (to.path === from.path) {
      return false;
    }

    setTimeout(() => {
      globalThis.scrollTo(0, 1);
    }, 400);
  });
});
